import React from 'react';
import {
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Skeleton,
} from '@mui/material';
import { useApiGet } from '../utils/httpClient';
import { getReciprocityTypes } from '../endpoints/chapters';

export default function ReciprocityType({ value, onUpdate }) {
  const { data } = useApiGet(['reciprocity-types'], getReciprocityTypes, {
    enabled: true,
    retry: 1,
  });

  return data ? (
    <FormControl fullWidth={true} variant="outlined" size="small">
      <InputLabel size="small" id="status">
        Reciprocity Type
      </InputLabel>
      <Select
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        fullWidth={true}
        variant="outlined"
        size="small"
        value={value || 'all'}
        label={'Reciprocity Type'}
        onChange={(event) => onUpdate(event.target.value)}
      >
        <MenuItem value={'all'}>All</MenuItem>
        {data.map((status) => (
          <MenuItem key={status.id} value={status.id}>
            {status.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  ) : (
    <Skeleton>
      <Select label="Reciprocity Type" />
    </Skeleton>
  );
}
